import { useCallback, useEffect } from 'react';

import { usePaginationControls } from 'helpers/hooks';

export const useDashboardDataTablePagination = ({ data }) => {
  const { paginationProps, paginationState, setTotalItems } = usePaginationControls({
    initialTotalItems: data.length,
  });

  const paginateRows = useCallback(
    rows => {
      const { page, size } = paginationState;
      return rows.slice((page - 1) * size, (page - 1) * size + size);
    },
    [paginationState]
  );

  useEffect(() => {
    setTotalItems(data.length);
  }, [data.length, setTotalItems]);

  return {
    paginationControls: {
      props: paginationProps,
      state: paginationState,
    },
    paginateRows,
  };
};
